// 資產表 - 繁體中文
export default {
  loading: { text: "拼命加載中" },
  table: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    empty: "暫無數據",
    asset: "資產",
    quantity: "數量",
    priceUSDT: "價格(USDT)",
    valueUSDT: "價值(USDT)",
  },
  tooltips: {
    price: "代幣價格為當前幣種對應的USDT價格，價格數據每日更新",
    value:
      "代幣價值是根據代幣價格計算得出，代幣價值受多種因素影響實時變化，此處代幣價值僅供參考",
  },
  labels: {
    updatedTimePrefix: "更新時間：",
  },
  bigAddress: {
    empty: "當前地址交易數據過度，僅支持輸入發送方/接收方地址的條件查詢",
  },
  downloadFileName: "數據明細",
};
